import { CreatorNotifications } from "./creator-notifications";
import { NotificationItemBase } from "./notification-item-base";

export class NotificationGroupItem extends NotificationItemBase {
    readonly id: string;
    readonly groups: CreatorNotifications[];
    readonly notifitionsCount: number;
    readonly date: Date;
}